import React, { useState } from 'react';
import Helpers from 'utils/helpers';
import Inputs from 'components/inputs/inputs';
import useInput from 'hooks/input';
import SiteSelectorModal from './siteSelectorModal';
import './siteSelectorFormControl.css';

export default function SiteSelectorFormControl(props) {
  const [showSitesPopup, setShowSitesPopup] = useState(false);

  const sitesSelected = props.sitesSelected || [];
  const disabled = props.disabled || false;
  const required = Helpers.Object.exists(props.required);
  const isInvalid = required && sitesSelected.length === 0;

  const { setInputRef } = useInput({ hasCustomError: isInvalid, customError: 'At last one site selection is required' });

  const handleClose = () => {
    setShowSitesPopup(false);
  };

  const onChange = (ids) => {
    props.onChange(ids);
  };

  const getDisplayValue = () => {
    if (sitesSelected.length === 1) {
      return <div>1 Site Selected</div>;
    }
    else {
      return <div>{sitesSelected.length} Sites Selected</div>;
    }
  };

  const getClass = () => {
    const classNames = ['site-selector-form-control'];
    if (disabled) {
      classNames.push('disabled');
    }
    if (isInvalid) {
      classNames.push('is-invalid');
    }
    return Helpers.String.join(classNames);
  };

  return (
    <>
      <div className={getClass()}>
        {sitesSelected.length > 0 ? <div className='site-selector-form-control-value'>{getDisplayValue(sitesSelected)}</div> : null}
        {sitesSelected.length === 0 ? <div className='px-3 py-2 opacity-90'>No Sites Selected</div> : null}
      </div>
      <div className='d-flex justify-content-between w-100'>
        {isInvalid && <div className='invalid-feedback site-selector-feedback'>At last one site selection is required</div>}
        <div></div>
        {disabled ? null :
          <div className='text-right'>
            <Inputs.Button variant='form' className='mt-2 mx-0' iconClass='icons8-edit-node' label='Select Sites' onClick={() => setShowSitesPopup(true)} />
          </div>
        }
      </div>
      {isInvalid && <input type='text' className='d-none' ref={setInputRef} />}
      {disabled ? null :
        <SiteSelectorModal
          areaId={props.areaId}
          areaName={props.areaName}
          show={showSitesPopup}
          onClose={handleClose}
          onChange={onChange}
          sitesSelected={sitesSelected}
          selectableFn={props.selectableFn}
        />
      }
    </>
  );
}